import { Paper, Grid, MenuItem } from "@mui/material";
import React from "react";
import CustomSelect from "../../components/select";
import { appIcons } from "../../assets";
import GlobalButton from "../../components/button";
import BoxContainer from "../../components/container/boxContainer";
import SchoolIcon from "@mui/icons-material/School";
import FormatIndentDecreaseIcon from "@mui/icons-material/FormatIndentDecrease";

const allPlatform = ["All", "Schools", "Colleges", "University"];
const applicationType = ["Apply For Admission", "Results"];

const Filters = ({
  location,
  setLocation,
  platform,
  setPlatform,
  applicationForm,
  setApplicationForm,
}) => {
  return (
    <BoxContainer>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4} md={3}>
          <CustomSelect
            placeholder={"location"}
            value={"location"}
            onChange={(e) => setLocation(e.target.value)}
            icon={<img src={appIcons.locationIcon} width={16} />}
          >
            <MenuItem value={"cant"}>Wah Cant,Lahore</MenuItem>
            <MenuItem value={"cant"}>Wah Cant,Islamabad</MenuItem>
            <MenuItem value={"cant"}>Wah Cant,Peshawer</MenuItem>
          </CustomSelect>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <CustomSelect
            placeholder={"Education Platform"}
            icon={
              <SchoolIcon htmlColor="#000000" sx={{ fontSize: "1.35rem" }} />
            }
          >
            {allPlatform?.map((val, index) => {
              return (
                <MenuItem key={index} value={val}>
                  {val}
                </MenuItem>
              );
            })}
          </CustomSelect>
        </Grid>
        <Grid item xs={12} sm={4} md={3}>
          <CustomSelect
            placeholder={"Application Form"}
            icon={
              <FormatIndentDecreaseIcon
                htmlColor="#000000"
                sx={{ fontSize: "1.35rem" }}
              />
            }
          >
            {applicationType?.map((val, index) => {
              return (
                <MenuItem key={index} value={val}>
                  {val}
                </MenuItem>
              );
            })}
          </CustomSelect>
        </Grid>

        <Grid item xs={12} sm={4} md={3}>
          <GlobalButton
            btnText={"Search"}
            styleProps={{
              width: "100%",
              backgroundColor: "text.coralRed",
            }}
          />
        </Grid>
      </Grid>
    </BoxContainer>
  );
};

export default Filters;
